
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-insurance/product/[slug]/useful-documents",
      function () {
        return require("private-next-pages/health-insurance/product/[slug]/useful-documents/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-insurance/product/[slug]/useful-documents"])
      });
    }
  